<template>
    <!-- First row: Invoice Summary -->
    <div class='invoice-sm-title p-2 pl-3 pr-3'>
        <div class="row">
            <div class='col-sm-6 text-left'>{{getText('InvoiceId')}}: <b>{{invoice().id}}</b></div>
            <div class='col-sm-6 text-right'>{{getText("AmountPayable")}}: <b>{{rateOffer().Symbol}}{{ getAmountPayable(invoice(), rateOffer().RateOffer)}} {{rateOffer().Currency}}</b></div>
        </div>
    </div>
</template>


<script>

import { mapGetters } from "vuex";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "InvoiceSummary",
    components: {},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
    getAmountPayable(invoice, rateOffer){
      let amountPayable;
      if(!invoice.amount_payable){
        amountPayable = (invoice.amount * rateOffer.Rate).toFixed(rateOffer.Units) || "--"
      }else{
        amountPayable = parseFloat(invoice.amount_payable).toFixed(rateOffer.Units);
      }
      return amountPayable;
    },
		...mapGetters(["invoice", "rateOffer", "merchant_currency"])
	}
};
</script>

<style scoped lang="scss">
	.invoice-sm-title{
        border: 1px solid #ebebeb;
        text-align: center;
        background-color: #f6f6f6;
        padding: 3px 0px;
        margin-bottom: 20px;
    }
</style>